import { api, setAuthHeader } from 'api';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const login = createAsyncThunk(
  'admin/login',
  async (credentials, thunkAPI) => {
    try {
      const { email = '', password = '' } = credentials;

      const { data } = await api.post('/admin/login', { email, password });
      if (data.token) {
        setAuthHeader(data.token);
      }
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);

export const logout = createAsyncThunk('admin/logout', async (_, thunkAPI) => {
  try {
    await api.post('/admin/logout');
    setAuthHeader(null);
    return true;
  } catch (error) {
    return thunkAPI.rejectWithValue(
      error.response?.data?.message || 'Logout failed'
    );
  }
});
